interface Args {
  data: Record<string, unknown>[];
  delimiter?: string;
  columns: string[];
  filename: string;
}

const CSV_FILE_TYPE = 'text/csv;charset=utf-8;';

export const downloadCsv = (csvAsString: string, filename: string) => {
  const byteOrderMark = '\ufeff';

  const blob = new Blob([byteOrderMark, csvAsString], {
    type: CSV_FILE_TYPE,
  });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const jsonToCsv = ({
  data,
  delimiter = ',',
  columns,
  filename,
}: Args) => {
  const dataArray = data.map((row) =>
    Object.entries(row)
      .map(([, value]) => JSON.stringify(value ?? ''))
      .join(delimiter)
  );
  dataArray.unshift(columns.join(delimiter));

  const csvAsString = dataArray.join('\r\n');

  downloadCsv(csvAsString, filename);
};
